import { BaseService } from "./base.service";
import { DebugMovementsResponse } from "@/types/movement";

export class MovementsDebugService extends BaseService {
  constructor() {
    super("/movements");
  }

  async getDebugMovements(
    memberId: string | null | undefined,
    params: {
      page?: number;
      limit?: number;
      category?: string;
      showSuperseded?: boolean;
    }
  ): Promise<DebugMovementsResponse> {
    const qsParams: Record<string, string> = {
      page: String(params.page ?? 1),
      limit: String(params.limit ?? 50),
      showSuperseded: String(params.showSuperseded ?? true),
    };
    if (memberId) qsParams.memberId = memberId;
    if (params.category) qsParams.category = params.category;
    const qs = new URLSearchParams(qsParams).toString();
    return this.get<DebugMovementsResponse>(`/debug?${qs}`);
  }
}

const movementsService = new MovementsDebugService();
export default movementsService;
